import {useRef} from 'react'
import {PUT, PATCH} from '../../services/api'

export const useSwitchStatus = () => {
  const loadingStatus = useRef<{[key: number]: boolean}>({})

  const switchStatus = async ({
    endpoint,
    Id,
    status,
    extraData = {},
    statusKey = 'status',
    method = 'PUT',
  }: {
    endpoint: string
    Id: number
    status: boolean | number
    extraData?: Record<string, any>
    statusKey?: string
    method?: 'PUT' | 'PATCH'
  }) => {
    const normalizedStatus = Boolean(status)
    const currentStatus = Id in loadingStatus.current ? loadingStatus.current[Id] : normalizedStatus
    loadingStatus.current[Id] = !currentStatus

    try {
      let response
      switch (method) {
        case 'PUT': {
          const body = {
            ...extraData,
            [statusKey]: Number(!currentStatus),
          }
          response = await PUT(`/${endpoint}/${Id}`, body)
          break
        }
        case 'PATCH': {
          const body = {
            id: Id,
            [statusKey]: Number(!currentStatus),
          }
          response = await PATCH(`/${endpoint}`, body)
          break
        }
        default:
          throw new Error(`Método não suportado: ${method}`)
      }

      return response
    } catch (e) {
      console.error(e)
    }
  }

  return {switchStatus}
}
